<template>
  <v-container class="page">
    <Headline
      :title="headlineText"
      icon="mdi-handshake-outline"
    />
    <router-view
      @setPageMode="setPageMode"
      @cancel="headlineText = $t('condAdmin.dealerList.headline')"
    ></router-view>
  </v-container>
</template>

<script lang="js">
import Headline from '@/common/Headline.vue';

export default {
  name: 'Dealer',
  components: {
    Headline
  },
  data () {
    return {
      pageMode: 'table', // values: table, edit
      headlineText: this.$t('condAdmin.dealerList.headline')
    };
  },
  methods: {
    setPageMode (mode, headlineParam = '') {
      this.pageMode = mode;
      switch (mode) {
        case 'create':
          this.headlineText = this.$t('condAdmin.dealerList.dealerCreate');
          break;
        case 'edit':
          this.headlineText = /* this.$t('condAdmin.dealerList.dealerEdit') + ': ' + */ headlineParam;
          break;
        default: // 'table':
          this.headlineText = this.$t('condAdmin.dealerList.headline');
          break;
      }
    }
  }
};
</script>

<style scoped lang="scss"></style>
